<template>

  <div class="termos__date-update-document">
          <span class="termos_date-update">
            Atualizado aos<br>
            05/04/2024
          </span>
  </div>

  <h1 class="termos__title-document">TERMO DE LICENÇA DE USO &dash; PRESTADOR 4 RODAS</h1>

  <p class="termos__paragraph-document">Estes termos e condições gerais se aplicam à licença de uso do aplicativo
    de propriedade da <strong>BOX DELIVERY
      S.A.,</strong> inscrita no CNPJ/ME sob o no 26.172.232/0001-10 ao usuário devidamente qualificado e
    identificado no
    <strong>CADASTRO</strong>, doravante denominado <strong>PRESTADOR.</strong>
  </p>

  <p class="termos__paragraph-document">
    O <strong>PRESTADOR </strong> se compromete a ler em sua integralidade o presente <strong>TERMO DE LICENÇA DE
    USO</strong>(“Termo”) e, ao
    aceitar eletronicamente, estará automaticamente aderindo e concordando em se submeter integralmente aos seus
    termos e condições.
  </p>

  <h2 class="termos__subtitle-document">CONSIDERANDO QUE:</h2>

  <ol class="termos__list-letters-document">
    <li class="termos__items-list-letters">
      a) A BOX é detentora de tecnologia própria e solução de logística para intermediação de
      entregas, incluindo os
      direitos relativos à toda propriedade industrial de qualquer natureza relacionada ao design, produção,
      desenvolvimento dos softwares, operação e uso das plataformas digitais;
    </li>
    <li class="termos__items-list-letters">
      b) O PRESTADOR manifesta a sua vontade em prestar seus serviços à BOX, sem regime de
      exclusividade e
      levando em consideração o quanto disposto no presente instrumento; e
    </li>
    <li class="termos__items-list-letters">
      c) A BOX e o PARCEIRO concordam em consolidar suas vontades para a prestação dos serviços,
      revogando
      qualquer outro acordo preestabelecido, seja escrito e/ou verbal.
    </li>
  </ol>

  <h1 class="termos__title-document">
    CAPÍTULO I <br>
    DAS DEFINIÇÕES
  </h1>

  <p class="termos__paragraph-document">
    1.1. De acordo com o art. 421-A, inciso I do Código Civil, os termos aqui inseridos terão os significados
    estabelecidos de acordo com a tabela a seguir, sendo que:
  </p>

  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">"BOX"</td>
      <td class="terms__definitions-clauses-description">Pessoa jurídica Box Delivery S.A., inscrita no CNPJ/ME
        sob o no
        26.172.232/0001-10, empresa titular do aplicativo “BOX 4
        RODAS”.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“BOX 4 RODAS”</td>
      <td class="terms__definitions-clauses-description">Sistema e aplicativo móvel disponível para a plataforma
        Android,
        de propriedade exclusiva da BOX.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“CADASTRO”</td>
      <td class="terms__definitions-clauses-description">Ficha cadastral completa com dados inseridos pelo
        PRESTADOR,
        permitindo o acesso gratuito ao aplicativo BOX 4 RODAS
        mediante login e senha.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“CARREGAMENTO”</td>
      <td class="terms__definitions-clauses-description">Local designado pelo COMERCIANTE para que o PRESTADOR
        efetue a coleta dos produtos e dê início ao seu percurso até o
        destino final.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“COMERCIANTE(S)”</td>
      <td class="terms__definitions-clauses-description">Pessoa física ou jurídica, sem vínculo empregatício com a
        BOX,
        que livremente se cadastra com o objetivo de localizar
        PRESTADORES e enviar uma OFERTA para entrega dos seus
        produtos.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“COMPROVANTE DE
        ENTREGA”</td>
      <td class="terms__definitions-clauses-description">Ato do PRESTADOR em inserir no aplicativo BOX 4 RODAS a
        nota
        fiscal dos produtos da ENTREGA, bem como o nome, o número
        da cédula de identidade e a assinatura do recebedor.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“CONCLUSÃO DA ENTREGA”</td>
      <td class="terms__definitions-clauses-description">Ato de confirmação pelo PRESTADOR, de que a entrega foi
        efetivada, ou, na ausência de confirmação, de forma automática
        pelo sistema BOX 4 RODAS.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“DISPUTA(S)”</td>
      <td class="terms__definitions-clauses-description">Aceite da OFERTA por diversos PRESTADORES para realização
        do
        serviço de entrega, sendo escolhido, ao final, aquele com a
        melhor proximidade do ponto de coleta dos produtos.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“ECOMMERCE”</td>
      <td class="terms__definitions-clauses-description">Compra e venda de bens e serviços pelos consumidores em
        plataformas de atacado e varejo online, incluindo, nessa espécie,
        as plataformas que agrupam e intermediam a venda de produtos
        de vários COMERCIANTES.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“ENTREGA(S)”</td>
      <td class="terms__definitions-clauses-description">Pedido realizado pelo COMERCIANTE para realização de
        entrega
        de sua OFERTA pelos PRESTADORES ao cliente final, o qual
        também poderá ser denominado simplesmente pedido.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“PRESTADOR(ES)”</td>
      <td class="terms__definitions-clauses-description">Pessoa física ou jurídica que se cadastra no aplicativo
        BOX 4
        RODAS de forma independente e, tendo seu cadastro aprovado,
        se habilita a realizar ENTREGA(S) aos COMERCIANTES conforme a
        sua disponibilidade, viabilidade ou desejo, de forma
        completamente autônoma, por meio de um dispositivo móvel. O
        PRESTADOR pode realizar a entrega por moto, veículo de
        passeio, utilitário, Van, VUC, Toco, Truck, Bi-truck ou Carreta,
        dependendo da logística da operação, sempre atuando de
        acordo com o modal selecionado no momento do CADASTRO.</td>
    </tr>
  </table>
  <table class="terms__definitions">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“SERVIÇOS”</td>
      <td class="terms__definitions-clauses-description">Pessoa física ou jurídica que se cadastra no aplicativo
        Acesso ao sistema via site (www.boxdelivery.com.br) da BOX,
        denominado TMS, que permite a OFERTA, pelo COMERCIANTE,
        de rotas com descrição dos produtos, assim como a localização
        de PRESTADORES para que sejam efetuadas as entregas de
        acordo com as especificações preenchidas.</td>
    </tr>
  </table>
  <table class="terms__definitions" id="terms__definitions_final">
    <tr class="terms__definitions-clauses">
      <td class="terms__definitions-clauses-entity">“TERCEIRO(S)”</td>
      <td class="terms__definitions-clauses-description">Pessoa ou entidade que não participa diretamente em um
        contrato, em um ato jurídico ou em um negócio, ou que, para
        além das partes envolvidas, pode ter interesse em um fato ou
        processo jurídico.</td>
    </tr>
  </table>

  <h1 class="termos__title-document">
    CAPÍTULO II <br>
    DO OBJETO
  </h1>

  <p class="termos__paragraph-document">
    <strong>2.1.</strong> O aplicativo BOX 4 RODAS oferece um ambiente virtual para que o PRESTADOR se cadastre,
    conforme etapas do formulário de CADASTRO e, mediante livre e espontânea vontade, execute o seu serviço
    ao COMERCIANTE que apresente uma OFERTA de ENTREGA, estando a BOX apenas como a intermediadora
    dessa relação.
  </p>

  <p class="termos__paragraph-document">
    <strong>2.2.</strong> O PRESTADOR se condiciona a leitura, ao entendimento e a concordância deste Termo, que
    confere a
    permissão de uso, incluindo as manutenções e hospedagens sistêmicas existentes do BOX 4 RODAS, por
    prazo indeterminado e com a finalidade de otimizar o contato entre COMERCIANTES e PRESTADORES na
    rede mundial de computadores, mediante dispositivos eletrônicos como <i>smartphones</i> ou <i>tablets</i>,
    operando
    em sistema operacional Android e com funcionalidade de localização geográfica por proximidade.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO III <br>
    DO CADASTRO
  </h1>

  <p class="termos__paragraph-document">
    <strong>3.1.</strong> O PRESTADOR tem ciência de que seu CADASTRO dependerá do envio, análise e aprovação da
    documentação solicitada pela BOX, qual seja: nome completo, RG, CPF, CNPJ (quando aplicável), CNH, data
    de nascimento, telefone, e-mail, endereço completo, tipo de veículo, documento identificador do veículo, ou
    seja, o registro nacional do veículo, também denominado RENAVAM, bem como a placa do automóvel.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.2.</strong> Uma vez aprovado o CADASTRO, o PRESTADOR se torna habilitado a acessar todas as
    funcionalidades inerentes ao BOX 4 RODAS, podendo participar de DISPUTAS em OFERTAS anunciadas pelos
    COMERCIANTES.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.3.</strong> Enquanto o CADASTRO estiver ativo, o PRESTADOR poderá utilizá-lo em qualquer dispositivo
    de
    telefonia móvel, com sistema operacional Android, através do login e senha de acesso, podendo encerrá-lo a
    qualquer momento, implicando na rescisão deste contrato para todos os fins e efeitos legais.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.4.</strong> O PRESTADOR garante que as informações constantes no CADASTRO são verdadeiras e atuais,
    e que
    serão mantidas sempre atualizadas, respondendo de forma integral em qualquer esfera, seja ela judicial ou
    administrativa, pelos dados inseridos.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.5.</strong> O PRESTADOR declara conhecer e responsabilizar-se integralmente pelo cumprimento dos
    requisitos
    legais da atividade, seja no âmbito federal, estadual ou municipal, especialmente a Lei Federal no
    <a href="nota1">12.009/2009[1]</a> ou a Lei Federal no <a href="#nota2">11.442/2007[2]</a>
    , conforme o caso, e ainda, por eventuais regimentos, normas
    de conduta, transporte e trânsito existentes, tais como ANTT, CONTRAN/DETRAN e Órgão de trânsito local,
    sem prejuízo de outras Leis Estaduais e Municipais que regulam esta categoria no local da prestação dos
    serviços, incluindo, mas não se limitando, a:
  </p>

  <p class="termos__paragraph-document">
    <strong>a. </strong> Ter 18 (dezoito) anos de idade;<br>
    <strong>b. </strong> Possuir e portar habilitação válida por pelo menos 2 (dois) anos na categoria;
  </p>

  <p class="termos__paragraph-document">
    <strong>c. </strong> Possuir todas as autorizações a conduzir e uma licença válida emitida por uma autoridade
    competente para a categoria e o tipo de veículo apropriados, quando aplicável a cada caso;<br>
    <strong>d. </strong> Em se tratando de uso de motocicleta, utilizá-la com baú ou mochila térmica, em perfeitas
    condições de uso e segurança, atendendo os padrões normativos, portando o documento de habilitação
    correspondente;<br>
    <strong>e. </strong> Conforme cada caso, utilizar cinto de segurança, capacete e colete que atendam as
    determinações
    técnicas exigidas pelos órgãos de trânsito; e<br>
    <strong>f. </strong> Agir com respeito e urbanidade nas relações interpessoais da atividade e respeitar as
    legislações de
    trânsito, especialmente o Código de Trânsito Brasileiro, conduzindo de forma prudente, evitando danos à
    mercadoria transportada.<br>
  </p>

  <p class="termos__paragraph-document">
    <strong>3.6.</strong> O PRESTADOR autoriza que o aplicativo forneça visibilidade de avaliações feitas por
    COMERCIANTES
    sobre as entregas que realizar, restando claro que a BOX não terá nem efetuará qualquer controle de
    quantidade ou conteúdo.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.7. </strong> De igual modo, o PRESTADOR poderá solicitar à BOX a retirada de avaliação que
    ultrapasse a esfera
    do serviço de entrega e contenha conteúdo ilegal, pejorativo, confidencial ou que fira sua imagem e honra
    pessoal, o qual terá o prazo de 48h para retirar o conteúdo do site, observados os artigos 19 e 20 da Lei
    12.965/2014 – Marco Civil da Internet.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.8.</strong> A BOX somente divulgará dados e avaliações dos PRESTADORES e COMERCIANTES quando
    expressamente autorizado por esses.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.9. </strong> Ao se cadastrar no aplicativo BOX 4 RODAS o PRESTADOR autoriza, a título gratuito, o
    uso de sua
    imagem e voz, em todo e qualquer material entre fotos, documentos e outros meios de comunicação, para
    campanhas promocionais e institucionais.
  </p>

  <p class="termos__paragraph-document">
    <strong>3.10. </strong> Do mesmo modo, o PRESTADOR concorda com a sua participação em campanhas com promoções
    em seu proveito, a partir da aprovação de seu CADASTRO.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO IV <br>
    Da interrupção
  </h1>

  <p class="termos__paragraph-document">
    <strong>4.1.</strong> Poderá ocorrer a interrupção do licenciamento de uso do aplicativo BOX 4 RODAS por
    iniciativa de
    qualquer das Partes, a qualquer momento, sem ônus, necessidade de justificativa e/ou de aviso prévio e
    sem que seja devido o pagamento de qualquer valor adicional.
  </p>

  <p class="termos__paragraph-document">
    <strong>4.2.</strong> O PRESTADOR terá sua conta do aplicativo BOX 4 RODAS temporariamente ou permanentemente
    interrompida, a critério da BOX, nos seguintes casos:
  </p>

  <ol class="termos__list-romans-document">
    <li class="termos__items-list-romans">
      A pedido do PRESTADOR, sem qualquer penalidade, recebendo os repasses dos seus ganhos até o
      momento da solicitação;
    </li>
    <li class="termos__items-list-romans">
      Após 90 dias sem a realização de quaisquer ENTREGAS, cabendo, neste caso, a sua reativação com a simples
      manifestação de interesse do PRESTADOR nos canais de comunicação da BOX;
    </li>
    <li class="termos__items-list-romans">
      Por decisão da BOX por descumprimento deste Termo, por mau uso, uso indevido ou abusivo do
      aplicativo BOX 4 RODAS, ou mesmo por mera liberalidade da BOX;
    </li>
    <li class="termos__items-list-romans">
      Por decisão da BOX por descumprimento deste Termo, por mau uso, uso indevido ou abusivo do
      aplicativo BOX 4 RODAS, ou mesmo por mera liberalidade da BOX;
    </li>
    <li class="termos__items-list-romans">
      Por má qualidade na prestação de serviço e infração de deveres cívicos, podendo contemplar, mas
      não limitado a:
    </li>
  </ol>
  <ol class="termos__list-llower-document">
    <li class="termos__items-list-lleters">
      Recorrentes avaliações negativas dos COMERCIANTES;
    </li>
    <li class="termos__items-list-lleters">
      Denúncia de atitudes desrespeitosas ou delituosas com COMERCIANTES e TERCEIROS;
    </li>
    <li class="termos__items-list-lleters">
      Subtração de produtos;
    </li>
    <li class="termos__items-list-lleters">
      Entregas realizadas de forma errada e/ou com má qualidade, como produtos e embalagens em
      mal estado, danificados e/ou corrompidos;
    </li>
    <li class="termos__items-list-lleters">
      Não movimentação do PRESTADOR após aceite do pedido desde que, simultaneamente,
      também não reporte à BOX a existência de uma dificuldade para realizar a ENTREGA;
    </li>
    <li class="termos__items-list-lleters">
      Comportamentos e condutas inadequados, podendo envolver agressões, intimidações,
      grosserias e uso de termos impróprios;
    </li>
    <li class="termos__items-list-lleters">
      Denúncias falsas e caluniosas que possam impactar a operação dos COMERCIANTES e da BOX;
    </li>
    <li class="termos__items-list-lleters">
      Por realizar interações indevidas com os COMERCIANTES ou TERCEIROS através da solicitação
      de informações pessoais ou tentativas de realização de ações delitivas, convencendo-os a
      realizar compras ou compartilhar informações com a intenção de cometer fraudes, podendo
      esta ser via contato telefônico ou pessoalmente, bem como qualquer outra conduta que
      contravenha às normas e bons costumes em detrimento da BOX e/ou aproveitando-se desta;
    </li>
    <li class="termos__items-list-lleters">Por determinação judicial, por requerimento de autoridade pública
      competente ou por se encontrar
      imerso em um processo penal ou envolvido diretamente em alguma investigação criminal na condição de autor,
      coautor ou partícipe do delito;</li>

    <li class="termos__items-list-lleters">Por causar danos ou prejuízos com atos que ferem o patrimônio e a
      boa-fé;</li>

    <li class="termos__items-list-lleters">Por usar as marcas, logotipos, nomes e insígnias de propriedade da BOX
      sem autorização prévia e por
      escrito dela ou por usar e aproveitar-se do uso do aplicativo BOX 4 RODAS para fazer publicidade e
      promover empresas alheias,</li>

    <li class="termos__items-list-lleters">Por encontrar-se sem as licenças e autorizações exigidas pela BOX para
      o uso da plataforma BOX 4
      RODAS, mesmo que apurado posteriormente a sua aprovação cadastral;</li>

    <li class="termos__items-list-lleters">Em outros casos onde a BOX entenda necessário, por violação de normas
      jurídicas, incompatibilidade
      com a política da plataforma BOX 4 RODAS, entre outras, como, por exemplo, prática de qualquer infração de
      trânsito ou conduta que implique risco de segurança ao trânsito e a integridade física do PRESTADOR ou de
      TERCEIROS,</li>

    <li class="termos__items-list-lleters">Condutas fraudulentas, danosas ou dolosas ou, ainda, a prática de
      atividades ilícitas por parte do
      PRESTADOR, podendo a BOX além de interromper seu acesso à plataforma, agir judicial ou extrajudicialmente
      contra o(s) envolvido(s) na conduta fraudulenta;</li>

    <li class="termos__items-list-lleters">Por cessão, comercialização ou uso da conta do PRESTADOR por outrem
      para a realização das ENTREGAS,
      sem a devida autorização ou atualização do CADASTRO;</li>

    <li class="termos__items-list-lleters">Em casos de ameaça à segurança e à integridade do aplicativo BOX 4
      RODAS, dos COMERCIANTES ou da
      BOX, em razão de suspeita de prática de infração penal prevista na legislação vigente;</li>
    <li class="termos__items-list-lleters">Descumprimento das obrigações constantes no presente Termo e nas
      legislações aplicáveis;</li>

    <li class="termos__items-list-lleters">Ocorrência de caso fortuito ou de força maior, regularmente comprovado,
      impeditivo da continuidade
      da prestação dos SERVIÇOS; e</li>

    <li class="termos__items-list-lleters">Falência ou recuperação judicial, dissolução ou liquidação judicial ou
      extrajudicial, requeridas ou
      homologadas pela BOX.</li>
  </ol>

  <p class="termos__paragraph-document">
    <strong>4.3. </strong> Em caso de contestação sobre a suspensão de sua conta, deverá ser encaminhado o pedido
    de
    revisão com os argumentos e provas adequadas para convencimento através do canal de suporte da BOX, o
    qual será analisado por equipe competente podendo ou não ser reativada sua conta por discricionariedade
    da BOX segundo aplicação das regras determinadas neste Termo de Uso.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO V <br>
    DAS CONDIÇÕES DE ENTREGA
  </h1>

  <p class="termos__paragraph-document">
    <strong>5.1. </strong> O PRESTADOR declara-se ciente de que os SERVIÇOS estão restritos ao acesso no sistema e
    aplicativo
    BOX 4 RODAS para livre DISPUTA de OFERTAS e realização de ENTREGAS.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.2.</strong>
    No momento em que uma OFERTA for disponibilizada no sistema BOX 4 RODAS, o PRESTADOR
    poderá visualizar todos os detalhes da rota da ENTREGA, sem que para isso tenha que aceitá-la, sendo
    facultativo o seu interesse em entrar no processo de DISPUTA. Em caso de confirmação na DISPUTA e
    designação de uma entrega, esta ficará disponível no campo de rotas a serem executadas, sendo certo que o
    seu cancelamento ocorrerá somente mediante o contato direto com a BOX em um de seus canais oficiais.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.3.</strong>
    O PRESTADOR responsabiliza-se integralmente pelo CARREGAMENTO informado na OFERTA de
    ENTREGA do COMERCIANTE, bem como pela eventual prestação do serviço de entrega, sendo certo que no
    caso de informação equivocada de endereços ou contato, o PRESTADOR deverá comunicar imediatamente à
    BOX.
  </p>
  <p class="termos__paragraph-document">
    <strong>5.4.</strong> O PRESTADOR declara-se ciente de que os produtos constantes no momento do CARREGAMENTO
    deverão, necessariamente, ser retirados lacrados e em embalagem original, sendo certo que caso o selo de
    segurança e/ou lacre de proteção esteja violado, deverá o PRESTADOR informar ao COMERCIANTE sobre tal
    situação e aguardar a regularização da OFERTA.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.5.</strong> Os itens entregues pelo PRESTADOR não poderão ser, em qualquer hipótese, alterados,
    trocados,
    provados, manipulados ou terem suas embalagens/invólucros violados, sob pena de ser debitado do seu
    extrato de ganhos no aplicativo BOX 4 RODAS.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.6.</strong> O PRESTADOR obriga-se, ainda, a comunicar a BOX caso, após chegar ao local indicado pelo
    COMERCIANTE, este não disponibilize o objeto da entrega para CARREGAMENTO no tempo indicado.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.7.</strong>De igual modo, o PRESTADOR se compromete a realizar a necessária confirmação da CONCLUSÃO
    DA ENTREGA, sendo desde já acordado que estas serão submetidas à análise da BOX para sua efetiva
    validação e posterior liberação dos valores.
  </p>

  <p class="termos__paragraph-document">
    <strong>5.7.1.</strong> No momento da indicação sobre a CONCLUSÃO DA ENTREGA, o PRESTADOR selecionará entre
    sucesso ou insucesso na geração do COMPROVANTE DE ENTREGA, conforme instruções divulgadas no
    aplicativo BOX 4 RODAS.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO VI <br>
    DA PRESTAÇÃO DOS SERVIÇOS
  </h1>

  <p class="termos__paragraph-document">
    <strong>6.1.</strong> A BOX e o PRESTADOR são independentes entre si e cada um é inteiramente responsável
    pelos seus
    custos operacionais, despesas, taxas, contribuições e impostos relativos à manutenção de seu negócio
    pessoal, empresarial e/ou da atividade econômica realizada entre si e perante TERCEIROS.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.2.</strong> O PRESTADOR é o único incumbido a arcar com os gastos e providências relativos a
    combustível,
    manutenção, licença do veículo, habilitação e documentos legais, devendo estes últimos serem coerentes
    com aqueles informados no CADASTRO, sendo certo que os COMERCIANTES poderão rejeitar o serviço de
    entrega caso verificada a incompatibilidade dos dados ou ocorrência de irregularidades, sem qualquer ônus.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.3.</strong> Do mesmo modo, o PRESTADOR é o único encarregado por obter os equipamentos e materiais
    necessários à execução da ENTREGA, compreendendo, mas não se limitando aos equipamentos obrigatórios
    de proteção individual.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.4.</strong> O PRESTADOR declara-se ciente e responsável pelo recolhimento dos tributos municipais,
    estaduais
    e federais incidentes sobre os serviços que prestar, na qualidade de pessoa jurídica, assim como na
    qualidade de prestador autônomo pessoa física pelo recolhimento dos tributos pessoais.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.5.</strong> O PRESTADOR será integralmente responsável pelo acesso à internet e funcionamento de seu
    dispositivo móvel, estando de pleno acordo com os requisitos mínimos para utilização do aplicativo,
    necessários à fruição do seu acesso ao aplicativo BOX 4 RODAS, estando a BOX livre e isenta de qualquer
    responsabilidade decorrente da não observância do aqui disposto.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.6.</strong> Toda e qualquer infração de trânsito ou dano que ocorra em decorrência direta ou
    indireta do
    serviço, incluindo, mas não se limitando a: (i) multas; (ii) acidentes; (iii) processos judiciais ou
    administrativos e (iv) danos e/ou extravio dos produtos entregues serão arcados única e exclusivamente pelo
    PRESTADOR, sem que a BOX seja de qualquer forma responsabilizada por esses eventos.

  </p>

  <p class="termos__paragraph-document">
    <strong>6.7.</strong> O PRESTADOR reconhece que não há relação empregatícia de qualquer espécie, e que serão
    as
    normas de Direito Civil a reger tal licenciamento, não sujeitando a BOX e o PRESTADOR aos deveres
    decorrentes da legislação trabalhista, previdenciária ou tributária específica, nem atribuindo às mesmas os
    direitos correspondentes, não constituindo o sistema e aplicativo BOX 4 RODAS como ferramentas essenciais
    para o desenvolvimento de sua atividade econômica, sendo certo que não há qualquer relação hierárquica,
    de dependência ou subordinação entre o PRESTADOR e a BOX, podendo o PRESTADOR livremente e em
    qualquer momento realizar ENTREGAS para quem desejar, assim como rejeitar, desativar e/ou desinstalar o
    aplicativo BOX 4 RODAS a qualquer momento, sem qualquer ônus e/ou penalidade.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.8.</strong> Em hipótese ou situação alguma se presumirá a eventual existência de vínculo societário
    e/ou
    empregatício, ou obrigações de caráter trabalhista e previdenciário entre BOX e PRESTADOR, seus
    contratados, prepostos e ou empregados, não sendo fiadoras das obrigações de encargos trabalhistas e
    sociais uma da outra, cabendo a cada um a exclusividade e responsabilidade por tais obrigações, inclusive
    nas esferas cível e criminal.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.9.</strong> O PRESTADOR deverá cumprir com as suas obrigações legais em relação ao seguro
    obrigatório no
    transporte rodoviário de cargas, quando exigível e conforme o veículo, a rota selecionada e/ou a pedido do
    COMERCIANTE, mantendo-o, às suas custas, quaisquer outras apólices que se façam necessárias, bem como
    quaisquer outras coberturas de seguro mínimo exigível, a exemplo, mas não se limitando ao seguro de
    responsabilidade civil geral, que atenda aos requisitos mínimos da operação.
  </p>

  <p class="termos__paragraph-document">
    <strong>6.10.</strong> A BOX poderá solicitar cópias de quaisquer apólices de seguro relevantes, contendo a
    data da sua
    vigência. Se, a qualquer momento, for identificada a expiração e/ou não renovação da apólice de seguro
    exigida, caberá ao PRESTADOR notificar imediatamente a BOX para que possa interromper a OFERTA de
    ENTREGAS de COMERCIANTES que exijam esse requisito.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO VII <br>
    Dos pagamentos
  </h1>

  <p class="termos__paragraph-document">
    <strong>7.1.</strong> O PRESTADOR reconhece que para viabilizar os pagamentos decorrentes das transações
    realizadas no
    âmbito do BOX 4 RODAS, a BOX possui diversos parceiros que atuam como instituições autorizadas a
    funcionar pelo Banco Central do Brasil. O aplicativo BOX 4 RODAS disponibiliza mais de uma possibilidade de
    pagamento ao PRESTADOR, sendo que, como padrão, ele receberá os pagamentos em uma data semanal fixa,
    toda quinta-feira (“Data Fixa”) ou, alternativamente, sempre que solicitar uma antecipação em relação a tal
    data fixa (“Antecipação Solicitada”).
  </p>

  <p class="termos__paragraph-document">
    <strong>7.2.</strong> Tanto os pagamentos realizados na Data Fixa quanto na Antecipação Solicitada ocorrem em
    datas
    anteriores ao previsto nos arranjos de pagamento que regulam as transações havidas no âmbito do BOX 4
    RODAS, assim, para viabilizar tal antecipação, o PRESTADOR outorga neste ato o presente mandato para que a
    BOX, em seu nome, negocie e ceda eventuais recebíveis do PRESTADOR vinculados às transações realizadas
    no âmbito do BOX 4 RODAS. Este mandato inclui a cessão dos recebíveis detidos pelo PRESTADOR
    decorrentes da ENTREGA realizada pelo PRESTADOR. O mandato aqui outorgado pelo PRESTADOR à BOX
    também abrange a realização dos registros de recebíveis sempre e quando for aplicável. Desta forma, o
    PRESTADOR reconhece que poderá receber valores a ele devidos antes do prazo estipulado pelos
    instituidores de arranjo de pagamento dentro dos quais se deram as transações cujos recebíveis foram
    cedidos.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.3.</strong> O PRESTADOR fará jus ao recebimento do valor indicado pelo COMERCIANTE, quando da
    publicação
    da OFERTA no aplicativo PARCEIRO BOX DELIVERY, podendo ocorrer situações em que haverá valor adicional
    em decorrência do aumento no número de OFERTA.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.4.</strong> A Antecipação Solicitada poderá ocorrer a qualquer tempo, de maneira parcial ou
    integral, e o
    PRESTADOR receberá instantaneamente através de transferência bancária, mediante a retenção de um
    percentual administrativo fixado em 4,99% (quatro inteiros e noventa e nove centésimos por cento) do valor
    resgatado, acrescido da cobrança de R$ 0,70 (setenta centavos).
  </p>

  <p class="termos__paragraph-document">
    <strong>7.4.1.</strong> O PRESTADOR reconhece e concorda expressamente que todo pagamento previsto neste
    capítulo
    será realizado exclusivamente em conta bancária de sua titularidade. Fica expressamente vedada a utilização
    de contas bancárias pertencentes a terceiros para a realização de tais transferências. O PRESTADOR se
    compromete a fornecer e manter atualizadas as informações de sua conta bancária para viabilizar as
    transferências acordadas.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.4.2.</strong> Caso haja qualquer dúvida, o prestador poderá entrar em contato com a BOX através do
    SAC
    constante no aplicativo BOX 4 RODAS.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.5.</strong> A BOX poderá reter os valores devidos ao PRESTADOR nos casos em que o COMPROVANTE DE
    ENTREGA, se devido, não for regularmente assinado ou nos casos em que haja contestação da ENTREGA
    sinalizada pelo COMERCIANTE.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.6.</strong> No caso do não pagamento de entregas pelo COMERCIANTE, a BOX garante o pagamento dos
    serviços efetivamente realizados ao PRESTADOR, na forma prevista nos parágrafos 1o e 2o deste capítulo.
  </p>

  <p class="termos__paragraph-document">
    <strong>7.7.</strong> O PRESTADOR poderá usufruir de parcerias intermediadas pela BOX mediante os termos e
    condições
    por eles estabelecidos, bem como pelo pagamento dos valores eventualmente acordados.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO VIII <br>
    DO PREÇO PELO USO DA PLATAFORMA
  </h1>

  <p class="termos__paragraph-document">
    <strong>8.1.</strong> A BOX receberá como contraprestação, em razão da utilização da plataforma, um valor
    semanal
    fixado em R$12,00 (doze reais), debitados do saldo disponível do PRESTADOR no aplicativo PARCEIRO BOX
    DELIVERY.
  </p>

  <p class="termos__paragraph-document">
    <strong>8.2.</strong> A contraprestação acima descrita será devida pelos PRESTADORES que recebam ENTREGAS de
    COMERCIANTES na modalidade ECOMMERCE, em função do alto volume de requisições sistêmicas.
  </p>

  <p class="termos__paragraph-document">
    <strong>8.3.</strong> A BOX é livre para alterar os valores conforme sua conveniência, em qualquer tempo,
    notificando
    previamente o PRESTADOR quando destas alterações.
  </p>

  <p class="termos__paragraph-document">
    <strong>8.4.</strong> A cobrança descrita no parágrafo 1o deste capítulo será válida a partir do 8o dia,
    contados da
    primeira ENTREGA realizada pelo PRESTADOR, sendo certo que caso o PRESTADOR não realize nenhuma
    entrega em determinada semana, não haverá desconto de valores referentes a esse período específico.
  </p>

  <p class="termos__paragraph-document">
    <strong>8.5.</strong> O valor sempre será debitado na semana posterior à que o PRESTADOR se encontra, às
    segundas-feiras, tendo como condição para a cobrança que o mesmo tenha efetuado pelo menos uma
    entrega.
  </p>

  <p class="termos__paragraph-document">
    <strong>8.6.</strong> Caso, por algum motivo, o PRESTADOR apresente insuficiência de saldo na plataforma BOX 4
    RODAS
    e, mesmo assim, tenha preenchido as condições para o débito do valor supracitado, este estará constituído
    em mora, podendo o valor ser retido das próximas entregas que venha a realizar.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO IX <br>
    DA PROPRIEDADE INTELECTUAL
  </h1>

  <p class="termos__paragraph-document">
    <strong>9.1.</strong> Todo o conteúdo disponível no aplicativo BOX 4 RODAS é de propriedade exclusiva da BOX,
    não devendo ser considerado como de domínio público. É proibida a sua cópia, reprodução, distribuição,
    transmissão, publicação, conexão ou qualquer outro tipo de modificação sem a prévia e expressa
    autorização da BOX. Ou seja, o PRESTADOR declara e reconhece que o download do aplicativo BOX 4 RODAS
    não lhe confere a propriedade sobre o conteúdo nela disponível.
  </p>

  <p class="termos__paragraph-document">
    <strong>9.2.</strong> Igualmente, todos os softwares são de propriedade da BOX, sendo concedido ao PRESTADOR
    somente a licença de uso, não exclusiva e revogável, sem qualquer autorização de cópia, cessão, reprodução,
    sublicença, engenharia reversa, mesclagem, incorporação em qualquer outro programa/sistema ou
    comercialização a qualquer título.
  </p>

  <p class="termos__paragraph-document">
    <strong>9.3.</strong> O PRESTADOR também se declara ciente de que esta licença não concede quaisquer direitos
    de uso
    sobre as marcas da BOX, extensão de e-mails ou, ainda, eventual domínio de sites, seja ou não para fins
    comerciais, senão para os exatos fins do presente Termo, também se sujeitando às sanções e penas previstas
    em lei.
  </p>

  <p class="termos__paragraph-document">
    <strong>9.4.</strong> Não é permitida a utilização de nenhum dispositivo, software, ou outro recurso que venha
    a
    interferir nas atividades e operações da BOX, bem como nas publicações de ofertas, descrições, contas ou
    seus bancos de dados. Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie as leis de
    direito de propriedade intelectual e/ou as proibições estipuladas neste instrumento, tornarão o responsável
    passível das ações legais pertinentes, bem como das sanções aqui previstas, sendo ainda responsável pelas
    indenizações por eventuais danos causados.
  </p>

  <p class="termos__paragraph-document">
    <strong>9.5.</strong> Em caso de infrações, o PRESTADOR estará sujeito às penalidades previstas nas Leis
    9.609/98 e
    9.610/98, sem prejuízo de outras medidas judiciais que se façam necessárias.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO X <br>
    DAS ALTERAÇÕES
  </h1>

  <p class="termos__paragraph-document">
    <strong>10.1.</strong> A BOX se reserva o direito de, periodicamente, ou a qualquer tempo que entender
    necessário,
    modificar ou corrigir eventuais dificuldades técnicas, características ou de manutenção das funções dos
    softwares, com ou sem aviso prévio, sem responsabilidade por eventuais falhas decorrentes de qualquer
    interrupção momentânea de uso do software, adstritas à natureza tecnológica.
  </p>

  <p class="termos__paragraph-document">
    <strong>10.2.</strong> A BOX poderá fazer, sempre que entender necessário, alterações e/ou atualizações no
    software
    e no presente Termo, sendo certo que o PRESTADOR será notificado via e-mail e <a href="#nota3"><i>pusher[3]</i></a> a para ciência e, ao
    continuar a utilizar os SERVIÇOS, estará expressando e reconhecendo a aceitação das referidas
    alterações/atualizações.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO XI <br>
    Da privacidade e proteção de dados
  </h1>

  <p class="termos__paragraph-document">
    <strong>11.1.</strong> A BOX possui uma política sobre privacidade e proteção de dados pessoais (“Política de
    Privacidade”), que pode ser acessada a qualquer tempo, mediante o link:<br>
    <a class="link-appearance"
       href="https://boxdelivery.com.br/politica-de-privacidade/">https://boxdelivery.com.br/politica-de-privacidade/</a>
  </p>

  <p class="termos__paragraph-document">
    <strong>11.2.</strong> O PRESTADOR concorda que a utilização do sistema e aplicativo BOX 4 RODAS implica na
    aceitação
    integral dos termos dispostos na Política de Privacidade e constitui parte integrante destes Termos.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.3.</strong> O PRESTADOR concorda expressamente que o uso da plataforma BOX 4 RODAS implica na
    coleta e
    utilização de seus dados pessoais, incluindo o processamento, armazenamento e compartilhamento, bem
    como, se necessário, o envio a autoridades competentes, conforme previsto na Política de Privacidade.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.4.</strong> Nos casos em que o PRESTADOR se filie a algum dos programas de benefícios ofertados
    pela BOX,
    seus dados pessoais poderão ser compartilhados com empresas parceiras para a efetiva aderência e fruição
    de tais benesses, sendo previamente informado para a devida autorização.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.5.</strong> A BOX poderá utilizar os dados pessoais do PRESTADOR, como nome e imagem para fins de
    divulgação promocional, bem como para participação em promoções. Para tanto, nos termos do artigo 7o, I
    da Lei no 13709/2018 o PRESTADOR consente a utilização dos dados especificamente para tais fins.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.6.</strong> Em caso de CADASTRO do PRESTADOR como MEI (Microempreendedor Individual) junto às
    empresas parceiras da BOX, o PRESTADOR autoriza o envio dos seus dados de faturamento para tais
    empresas, exclusivamente para fins de emissão de Nota Fiscal.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.7.</strong> Nos casos de interrupção do acesso a conta pelo PRESTADOR, seus dados poderão ser
    compartilhados com parceiros de negócios da BOX, juntamente com o número de identificação da ENTREGA
    e o motivo que ensejou sua interrupção, temporária ou permanente, do aplicativo BOX 4 RODAS.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.8.</strong> A BOX não divulgará a terceiros, salvo nas hipóteses previstas nesse Termo e/ou na
    Política de
    Privacidade, os dados cadastrais inseridos pelo PRESTADOR no CADASTRO, durante a vigência e após o
    término dos seus serviços, garantindo a confidencialidade das informações.
  </p>

  <p class="termos__paragraph-document">
    <strong>11.9.</strong> O PRESTADOR poderá revogar seu consentimento, a qualquer tempo, por e-mail dirigido ao
    nosso
    Encarregado de Dados (<a class="link-appearance" href="mailto:dpo@boxdelivery.com.br">dpo@boxdelivery.com.br</a>).
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO XII <br>
    DA CONFIDENCIALIDADE
  </h1>

  <p class="termos__paragraph-document">
    <strong>12.1.</strong> O PRESTADOR assume o compromisso de manter absoluto sigilo de todas as informações,
    sejam de
    natureza comercial, econômico-financeira, técnica, administrativa ou operacional, bem como quaisquer
    outras informações e documentos relacionados à BOX, às suas atividades e/ou aos COMERCIANTES ou
    TERCEIROS a que venha a ter acesso em decorrência do seu cadastro na plataforma BOX 4 RODAS.
  </p>

  <p class="termos__paragraph-document">
    <strong>12.2.</strong> O PRESTADOR declara-se ciente de que as informações, documentos e dados pessoais que
    tenha
    acesso, deverão ser utilizados estritamente para a realização das ENTREGAS, ficando proibido qualquer tipo
    de divulgação ou compartilhamento, no todo ou em parte, das informações que tenha acesso.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO XIII <br>
    DAS RESPONSABILIDADES
  </h1>

  <p class="termos__paragraph-document">
    <strong>13.1.</strong> A BOX não assume qualquer responsabilidade pela OFERTA, seu conteúdo, CARREGAMENTO,
    DISPUTA, COMPROVANTE DE ENTREGA e/ou CONCLUSÃO DA ENTREGA, não atestando a regularidade de
    produtos ou habilitação técnica, idoneidade ou capacidade legal ou física dos PRESTADORES, tampouco
    quanto ao cumprimento das leis aplicáveis, aos documentos e informações inseridas no CADASTRO e nas
    OFERTAS, sobre o qual não se obriga a realização de análises.
  </p>

  <p class="termos__paragraph-document">
    <strong>13.2.</strong> A BOX não assume qualquer participação em eventual relação contratual estabelecida
    entre
    PRESTADOR e COMERCIANTE, limitando-se tão somente a otimizar o contato e possibilitar a aproximação
    geográfica entre estes por meio da plataforma em questão – BOX 4 RODAS. Desta forma, quaisquer defeitos,
    perdas, danos relativos às OFERTAS e ENTREGAS serão de responsabilidade exclusiva destas partes.
  </p>

  <p class="termos__paragraph-document">
    <strong>13.3.</strong> Em qualquer hipótese, a BOX não será responsável por eventuais acidentes, sejam quais
    forem suas
    origens ou condições, independente da ocorrência de culpa ou dolo no resultado, tampouco dos atos ilícitos
    praticados por ou envolvendo PRESTADOR e COMERCIANTE, por ocasião de OFERTAS e DISPUTAS aceitas, os
    quais assumem integralmente os riscos inerentes ao transporte e entrega.
  </p>

  <p class="termos__paragraph-document">
    <strong>13.4.</strong> A incitação de terceiros, prestadores ou não, ou participação comprovada do PRESTADOR
    em atos
    pessoais ou virtuais que possam atingir à honra objetiva, que afetem a reputação ou imagem no mercado,
    ou ainda, que resulte em prejuízos à BOX, ensejará a imediata rescisão contratual com a consequente
    interrupção do CADASTRO de forma definitiva e irrevogável, sem prejuízo da reparação dos danos causados
    na esfera moral e patrimonial nos termos dos artigos 186,187 e 927 do Código Civil.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO XIV <br>
    DAS INFORMAÇÕES GERAIS
  </h1>

  <p class="termos__paragraph-document">
    <strong>14.1.</strong> O descumprimento de qualquer obrigação ou infração ao estabelecido no presente Termo
    pelo
    PRESTADOR ensejará, além do direito à rescisão pela BOX e interrupção do CADASTRO, à multa de um salário
    mínimo vigente, durante os meses em que perdurar a infração, independente de notificação e sem prejuízo
    de eventual indenização por perdas e danos materiais e morais devidamente comprovados.
  </p>

  <p class="termos__paragraph-document">
    <strong>14.2.</strong> A tolerância da BOX com o PRESTADOR, quanto ao descumprimento de qualquer das
    obrigações ora
    assumidas, não será considerada novação ou renúncia de qualquer direito, constituindo mera liberalidade,
    que não impedirá a BOX de exigir posteriormente o fiel cumprimento das condições previstas neste Termo, a
    qualquer tempo.
  </p>

  <p class="termos__paragraph-document">
    <strong>14.3.</strong> As normas relativas ao uso do aplicativo BOX 4 RODAS estão descritas nos softwares,
    cuja obrigação
    e responsabilidade de leitura e manuseio é exclusiva do PRESTADOR.
  </p>

  <p class="termos__paragraph-document">
    <strong>14.4.</strong> O PRESTADOR declara e aceita expressamente que:
  </p>

  <ol class="termos__list-letters-document">
    <li class="termos__items-list-letters">
      <strong>a)</strong> Está ciente de que a BOX oferece aos PRESTADORES um seguro de acidentes pessoais, válido
      durante a
      realização das ENTREGAS. As informações detalhadas sobre a cobertura do seguro e instruções para
      acessá-lo podem ser encontradas através do link:
      <a class="link-appearance"
         href="https://88iseguradora.digital/acidentes-pessoais-boxdelivery/">https://88iseguradora.digital/acidentes-pessoais-boxdelivery/</a>.
    </li>
    <li class="termos__items-list-letters">
      <strong>b)</strong> Não utilizará para proveito próprio ou de terceiras quaisquer informações relacionadas
      aos produtos
      constantes na OFERTA, às ENTREGAS, aos COMERCIANTES ou a TERCEIROS e afins, ou qualquer
      informação que tenha acesso em virtude da presente autorização, razão pela qual se obriga a não
      armazenar nem tratar os dados pessoais obtidos, nem a entrar em contato depois de haver entregado,
      declinado ou cancelado qualquer OFERTA de COMERCIANTES.
    </li>
    <li class="termos__items-list-letters">
      <strong>c)</strong> A BOX poderá modificar unilateralmente, em qualquer momento e sentido, o presente Termo,
      sendo
      responsabilidade do PRESTADOR a verificação na plataforma BOX 4 RODAS por eventuais atualizações
      deste Termo.
    </li>
    <li class="termos__items-list-letters">
      <strong>d)</strong> Deverá o PRESTADOR assumir todas as responsabilidades por condutas indevidas ou ilegais
      que
      pratique;
    </li>
    <li class="termos__items-list-letters">
      <strong>e)</strong> Não utilizará o nome da BOX e de seus sócios ou representantes a qualquer título, para
      obter vantagens
      extracontratuais, para si ou terceiros, junto aos COMERCIANTES ou qualquer TERCEIRO, bem como a
      não realizar atividades que possam concorrer de forma direta com a BOX enquanto vigorar o presente
      Termo, sob pena de rescisão definitiva e irrevogável do presente.
    </li>
    <li class="termos__items-list-letters">
      <strong>f)</strong> Obriga-se a utilizar a marca, imagem, nome ou qualquer informação obtida em decorrência
      do presente
      Termo tão somente para os fins ora contratados, na forma autorizada e em benefício geral e exclusivo
      da BOX.
    </li>
    <li class="termos__items-list-letters">
      <strong>g)</strong> O PRESTADOR compromete-se a utilizar o software de forma idônea, respeitando sua
      finalidade e
      comprometendo-se a cumprir o disposto no presente.
    </li>
    <li class="termos__items-list-letters">
      <strong>h)</strong> É vedada toda e qualquer cobrança de valores em máquinas de cartão próprias do
      PRESTADOR,
      inclusive valores a título de gorjeta; e
    </li>
    <li class="termos__items-list-letters">
      <strong>i)</strong> Que teve a oportunidade de ler o presente Termo, assim como sanar quaisquer dúvidas em
      relação aos
      seus capítulos e condições antes do seu aceite. O PRESTADOR reconhece e manifesta sua concordância
      integral com os Termos aqui descritos.
    </li>
  </ol>

  <p class="termos__paragraph-document">
    <strong>14.5.</strong> Em caso de discordância de quaisquer das disposições o PRESTADOR poderá proceder, sem
    qualquer
    ônus, ao encerramento do seu CADASTRO.
  </p>

  <h1 class="termos__title-document">
    CAPÍTULO XV <br>
    DO FORO
  </h1>

  <p class="termos__paragraph-document">
    <strong>15.1.</strong> As partes estão sujeitas à legislação brasileira, sendo eleita a jurisdição do Foro
    Central da cidade de
    São Paulo/SP, para resolução de quaisquer conflitos, disputas, reivindicações ou controvérsia que
    eventualmente possam surgir em relação ao presente termo.
  </p>

  <hr class="terms__line">

  <p id="terms__final-document" class="termos__paragraph-document">
          <span id="nota1">
            ¹ Lei que regulamenta o exercício das atividades dos profissionais em transporte de passageiros,
            “mototaxista”, em entrega de
            mercadorias e em serviço comunitário de rua, e “motoboy”, com o uso de motocicleta.
          </span><br>

    <span id="nota2">
            ² Lei que regulamenta o transporte rodoviário de cargas por conta de    terceiros
          </span><br>
    <span id="nota3">
            ³ Método de comunicação utilizado por aplicativos em dispositivos móveis (smartphones e tablets)
          </span>
  </p>
</template>

<style scoped lang="scss">

</style>
